import { useQuery } from '@tanstack/react-query';
import { promotionQueries } from '../api/promotion-queries';
import type { PromotionFilters, PromotionListScope } from '../api/promotion-api';

/**
 * The merchant's promotions, narrowed by the filter bar.
 *
 * No merchant scope is threaded through: the backend derives it from the
 * caller's token. The FILTERS are threaded through, because the endpoint
 * applies them — passing none reads the unfiltered list.
 */
export function usePromotions(
  filters: PromotionFilters = {},
  scope: PromotionListScope = { branches: [] },
  options?: { enabled?: boolean },
) {
  return useQuery(promotionQueries.list(filters, scope, options));
}

export function usePromotionProductRows(filters: PromotionFilters = {}) {
  return useQuery(promotionQueries.productRows(filters));
}

/**
 * One promotion's own record AT ONE BRANCH, for seeding the edit modal.
 *
 * Branch-scoped because the endpoint is: `restaurant_id` is required, and the
 * `productIds` that come back are the ones covered at that branch alone. The
 * wizard reads a branch when the merchant opens it, so a campaign spanning
 * several branches is fetched a branch at a time rather than all at once.
 *
 * Idle while either id is missing — a create has nothing to read, a closed
 * modal has no target, and no branch selected yet has nothing to scope to.
 */
export function usePromotionDetail(
  id: string | undefined,
  restaurantId: string | undefined,
) {
  return useQuery(promotionQueries.detail(id, restaurantId));
}
